/** ************************
 Lobby Notification
 dependency: noty
 ************************* */
var LobbyNotification = function (config) {
  this.defaults = {
    text: 'Lobby Notification',
    layout: 'centerRight',
    dismissQueue: true,
    type: 'information',
    closeWith: ['click', 'button'],
    animation: {
      open: 'animated bounceInRight',
      close: 'animated bounceOutRight'
    }
  };

  if (config != undefined && config instanceof Object) {
    jQuery.extend(this.defaults, config);
  }
};

LobbyNotification.prototype.alert = function (msg, config) {
  this.show(msg, jQuery.extend({}, { type: 'alert' }, config));
};

LobbyNotification.prototype.notice = function (msg, config) {
  this.show(msg, jQuery.extend({}, { type: 'notification' }, config));
};

LobbyNotification.prototype.warning = function (msg, config) {
  this.show(msg, jQuery.extend({}, { type: 'warning' }, config));
};

LobbyNotification.prototype.error = function (msg, config) {
  this.show(msg, jQuery.extend({}, { type: 'error' }, config));
};

LobbyNotification.prototype.info = function (msg, config) {
  this.show(msg, jQuery.extend({}, { type: 'information' }, config));
};

LobbyNotification.prototype.success = function (msg, config) {
  this.show(msg, jQuery.extend({}, { type: 'success' }, config));
};

LobbyNotification.prototype.lobbyToggle = function (isEnabled) {
  var path = window.location.pathname.toLowerCase();

  var lobbyWidgetsContainer = $('#lobbyWidgetsContainer');
  var lobbyMaintenance = $('#lobbyMaintenance');
  var lobbyPage = $('#lobby-rooms-page');

  if (path.search(/lobby/) != -1) {
    if (isEnabled) {
      lobbyMaintenance.removeClass('lobbyMaintenance--active');
      lobbyWidgetsContainer.removeClass('lobbyWidgetsContainer--disabled');
      lobbyPage.removeClass('lobbyRoomsPage--disabled');
      window.location.reload();
    } else {
      lobbyMaintenance.addClass('lobbyMaintenance--active');
      lobbyWidgetsContainer.addClass('lobbyWidgetsContainer--disabled');
      lobbyPage.addClass('lobbyRoomsPage--disabled');
    }
  }
};

LobbyNotification.prototype.show = function (msg, config) {
  config.text = msg;
  var run = jQuery.extend({}, this.defaults, config);
  new Noty(run).show();
};
